import * as React from "react";

import type { DesignaliProps } from "../../types";

export const ThreadsFill = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          d="M2,17.77c0-3.85,0-7.7,0-11.54,0-.03.02-.06.03-.1.32-1.99,1.43-3.32,3.36-3.94.28-.09.58-.13.87-.19,3.83,0,7.66,0,11.48,0,.03,0,.07.02.1.03.4.1.82.17,1.2.31,1.76.67,2.95,2.43,2.95,4.32,0,3.54,0,7.08,0,10.62,0,.55-.09,1.07-.27,1.59-.75,2.13-2.73,3.12-4.39,3.12-3.54,0-7.08,0-10.62,0-.3,0-.62-.02-.91-.09-1.9-.43-3.15-1.57-3.66-3.47-.06-.22-.1-.44-.14-.66ZM5.5,12.12c0,.2.02.52.04.84.09,1.13.34,2.22.84,3.24.61,1.25,1.53,2.2,2.83,2.74.87.36,1.79.53,2.74.55,1.11.02,2.18-.15,3.17-.63,1.51-.74,2.49-1.89,2.69-3.6.11-.95-.13-1.83-.7-2.6-.4-.55-.93-.94-1.55-1.22-.11-.05-.16-.12-.17-.25-.01-.21-.04-.42-.09-.63-.22-1.02-.72-1.84-1.71-2.27-.77-.34-1.58-.4-2.4-.2-.72.17-1.28.58-1.74,1.15-.07.08-.09.16.01.23.28.19.57.38.85.57.08.05.15.04.21-.03.45-.54,1.05-.71,1.73-.69.92.03,1.51.5,1.72,1.39.04.18,0,.22-.2.21-.52-.02-1.05-.04-1.57-.04-.48,0-.95.1-1.4.29-1,.42-1.61,1.3-1.59,2.31.01,1,.64,1.87,1.62,2.25.57.22,1.17.24,1.77.16.95-.13,1.7-.57,2.18-1.42.26-.45.42-.92.54-1.42.04-.17.11-.2.25-.09.81.62,1.15,1.56.88,2.55-.31,1.14-1.08,1.88-2.16,2.29-1.14.43-2.32.48-3.51.24-1.52-.31-2.66-1.14-3.31-2.58-.37-.81-.55-1.67-.62-2.56-.1-1.26,0-2.51.37-3.72.46-1.51,1.41-2.57,2.93-3.07,1.21-.39,2.44-.42,3.68-.09,1.03.28,1.9.81,2.53,1.69.36.5.61,1.05.77,1.64.03.11.07.2.21.16.32-.09.64-.17.96-.26.11-.03.14-.09.1-.2-.06-.17-.1-.34-.16-.51-.64-1.74-1.81-2.98-3.56-3.63-1.31-.49-2.67-.55-4.04-.3-2.13.38-3.6,1.58-4.45,3.55-.53,1.22-.68,2.52-.7,3.95Z"
        />
        <path
          strokeWidth={0}
          d="M12.74,12.17c.38.04.77.09,1.17.13.09.01.15.05.14.15-.04.68-.23,1.3-.76,1.76-.55.48-1.18.52-1.84.3-.21-.07-.42-.17-.59-.3-.4-.31-.48-.78-.23-1.22.23-.41.6-.63,1.05-.7.35-.06.7-.07,1.06-.11Z"
        />
      </svg>
    );
  },
);

export default ThreadsFill;
